import type { QuickSuggestion, ContactCTA } from '@brochure/shared'

/**
 * Quick suggestion buttons shown when the chat is empty.
 * Each entry uses i18n translation keys for label and message.
 *
 * Example:
 * ```ts
 * export const quickSuggestions: QuickSuggestion[] = [
 *   {
 *     id: '1',
 *     labelKey: 'chatbot.suggestions.services',
 *     messageKey: 'chatbot.suggestions.servicesMessage',
 *   },
 * ]
 * ```
 */
export const quickSuggestions: QuickSuggestion[] = []

/**
 * Contact CTA buttons shown below each assistant message.
 * Leave empty to hide CTAs entirely.
 *
 * Two kinds are supported:
 *
 * - `copy`: click copies `value` to the clipboard and shows a "copied"
 *   confirmation. Ideal for phone numbers, emails, addresses.
 *   Built-in icons available for `id: 'phone'` and `id: 'email'`.
 *
 * - `link`: opens `url` in a new tab, optional image `icon`.
 *   Ideal for WhatsApp, Telegram or any external contact channel.
 *
 * Example:
 * ```ts
 * import whatsappIcon from '@/assets/images/icons/whatsapp.png'
 *
 * export const contactCTAs: ContactCTA[] = [
 *   {
 *     kind: 'copy',
 *     id: 'phone',
 *     labelKey: 'chatbot.cta.phone',
 *     value: '+39 000 0000000',
 *   },
 *   {
 *     kind: 'copy',
 *     id: 'email',
 *     labelKey: 'chatbot.cta.email',
 *     value: 'info@example.com',
 *   },
 *   {
 *     kind: 'link',
 *     id: 'whatsapp',
 *     labelKey: 'chatbot.cta.whatsapp',
 *     url: 'https://wa.me/393400000000',
 *     icon: whatsappIcon,
 *   },
 * ]
 * ```
 */
export const contactCTAs: ContactCTA[] = []
